<template>
  <div class="home">
    <div class="link-container">
      <span class="link-text" @click="router.push('/jinjunfu/gold')">
        私有_今君福_金价 → /jinjunfu/gold
      </span>

      <span class="link-text" @click="router.push('/jinjunfu/wxMinShop')">
        (弃用)_微信小店二维码 → /jinjunfu/wxMinShop
      </span>

      <span class="link-text" @click="router.push('/about')">
        About 页面 → /about
      </span>
      <span class="link-text" @click="router.push('/closingLine/cutGood')">
        服装尾盘 →  /closingLine/cutGood
      </span>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
</script>

<style scoped>
.home {
  display: flex;
  justify-content: left;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
}

.link-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 600px; /* PC端最大宽度限制 */
  width: 100%;
}

.link-text {
  font-size: 18px;
  color: #1989fa; /* Vant主题蓝色 */
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 4px;
  display: inline-block;
}

.link-text:hover {
  background-color: #f7f8fa;
  color: #0077e6;
  transform: translateX(5px);
}


.link-text:hover::after {
  opacity: 1;
}
</style>